
      import EmailFill from './email-fill.vue'
      import type { App, Plugin } from 'vue'

      export const EmailFillPlugin: Plugin = {
        install(app: App) {
          app.component('EmailFill', EmailFill)
        },
      }
      export { EmailFill }
      